import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useState} from 'react';
import {useNavigate,useParams} from 'react-router-dom';

import AppDashboard from '../AppDashboard';
import LoadingScreen from '../../components/common/LoadingScreen';
import SessionTypeForm from '../../components/scheduling/SessionTypeForm';
import {useGetCurrentProviderQuery} from '../../redux/services/providerApi';
import {useCreateSessionTypeMutation} from '../../redux/services/sessionTypeApi';
import {useGetSessionTypeTemplatesQuery} from '../../redux/services/sessionTypeTemplateApi';
import useError from '../../hooks/useError';

const handleSubmit = ({
  createSessionTypeMutation,
  setError,
  onBack,
  providerId
}) => async formData => {
  const res = await createSessionTypeMutation(formData);
  if (res?.error) {
    const message = res?.error?.data?.errors?.[0];
    setError({message});
  } else {
    onBack();
  }
};

const NewProviderSessionTypePage = props => {
  const navigate = useNavigate();
  const {templateId} = useParams();
  const providerQuery = useGetCurrentProviderQuery();
  const [createSessionTypeMutation] = useCreateSessionTypeMutation();
  const errors = useError();
  const setError = errors.create;
  const providerId = get(providerQuery, 'data.id', null);
  const templateQuery = useGetSessionTypeTemplatesQuery({id: templateId}, {skip: !templateId});
  const template = templateQuery?.data?.data?.[0];
  const onBack = () => navigate(`/providers/${providerId}/session-types/list`);
  const onSubmit = handleSubmit({
    createSessionTypeMutation,
    providerId,
    setError,
    onBack,
  });
  const childProps = {
    ...props,
    setError: err => errors.create(err),
    isEditingExistingSessionType: false,
    onCancel: onBack,
    onSubmit: onSubmit,
    template,
  };
  return (
    <AppDashboard
      title='Session Types'
      onBack={onBack}
    >
      {templateId && (!template || templateQuery.isLoading)
        ? <LoadingScreen />
        : <SessionTypeForm {...childProps } />
      }
    </AppDashboard>
  );
};

NewProviderSessionTypePage.defaultProps = {
};

NewProviderSessionTypePage.propTypes = {
};

export default NewProviderSessionTypePage;
